import Icon from '../components/Icon.vue'

Icon.register({
  stethoscope: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M447.1 112c35.7-0.5 64.9 28.3 64.9 64 0 23.7-12.9 44.3-32 55.4v112.6c0 92.6-79 168-176 168-95.4 0-173.3-72.8-175.9-163.2-73-14.8-128.1-79.5-128.1-156.8v-155.4c0-11.5 8.1-21.3 19.3-23.6l62.8-12.4c13-2.6 25.6 5.8 28.2 18.8l3.1 15.7c2.6 13-5.8 25.6-18.8 28.2l-30.7 6.1v122.5c0 53.3 43.5 96.5 96.9 96 52.9-0.5 95.1-44.3 95.1-97.2v-121.4l-30.7-6.1c-13-2.6-21.4-15.2-18.8-28.2l3.2-15.7c2.6-13 15.2-21.4 28.2-18.8l62.9 12.6c11.2 2.2 19.3 12.1 19.3 23.5v155.4c0 77.2-55 141.8-127.8 156.8 2.7 55.1 51.9 99.2 111.9 99.2 61.8 0 112-46.7 112-104v-112.6c-19.5-11.2-32.5-32.5-32-56.8 0.7-34.2 28.8-62.1 63-62.6zM448 192c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z'
      }
    ]
  }
})
